export default "__VITE_ASSET__BJ_jX336__"